import { apiSlice } from "../api/apiSlice";

export const permisosApi = apiSlice.injectEndpoints({
  endpoints: (builder)=>({
    permisos: builder.query({
      query: () => 'permisos',
      providesTags: (result, error, arg)=>[
        {type:'Permisos', id: 'LIST'},
      ]
    }),
    permisosRolesMap: builder.query({
      query: () => 'permisos_roles_map',
      providesTags: (result, error, arg)=>[
        {type:'permisosRolesMap', id: 'LIST'},
      ]
    }),
  })
})

export const { usePermisosQuery, usePermisosRolesMapQuery } = permisosApi;